"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
const BaseError_1 = require("./BaseError");
class ApiError extends BaseError_1.BaseError {
    constructor(description = "Api call failed", status = 500) {
        super("ApiError", status, description, true);
    }
}
exports.ApiError = ApiError;
